import React from "react";
import "./navbar.css"
import {NavLink} from "react-router-dom";

const Navbar = () => {
    return(
        <div className="navbar-border">
            <nav className="navbar">
                <NavLink to="/">
                    Home
                </NavLink>
                <NavLink to="/author">
                    About
                </NavLink>
                <NavLink to="/books">
                    Books
                </NavLink>  
                <NavLink to="/reviews">
                    Reviews
                </NavLink>  
                <NavLink to="/newsletter">
                    Newsletter
                </NavLink>
            </nav>
        </div>
    )
}

export default Navbar